import { Route, Routes } from 'react-router-dom';

import { AppShell } from './components/AppShell';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PostAuthRedirectPage } from './pages/PostAuthRedirectPage';

export function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/post-auth" element={<PostAuthRedirectPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AppShell>
  );
}
